var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"display":"inline-flex","align-items":"center"},on:{"click":_vm.onClick}},[(_vm.icon)?_c('kl-icon',{attrs:{"icon":_vm.icon,"size":_vm.iconSize}}):_vm._e(),_c('span',{style:({ 'color': _vm.color, 'font-weight': _vm.bold ? 'bold' : '0', 'font-size': _vm.fontSize + 'px' })},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }